import React from 'react';

// Console test (check browser's dev tools)
console.log(
  "[Debug] REACT_APP_TEST_VALUE:", 
  process.env.REACT_APP_TEST_VALUE
);

const Testingpages = () => {
  return (
    <div>
      <h2>Environment Variable Test</h2>
      <p>
        Value from <code>.env</code>:<br />
        <strong style={{ color: 'green' }}>
          {process.env.REACT_APP_TEST_VALUE || "❌ NOT FOUND!"}
        </strong>
      </p>
    </div>
  );
};

export default Testingpages;